<div class="flex items-center justify-end space-x-2 shrink-0 border-t border-gray-200 py-1 sticky bottom-0 bg-white mr-0 md:mr-8" *ngIf="totalCount > 0">
    <div class="flex items-center text-xs md:text-sm mr-2" *ngIf="showPageSizeSelector">
        <span class="mr-2">Velikost stránky:</span>
        <ng-select
            class="w-20 text-md"
            [items]="pageSizeOptions"
            [clearable]="false"
            [searchable]="false"
            [ngModel]="pageSize"
            (ngModelChange)="onPageSizeChange($event)">
        </ng-select>
    </div>

    <span class="text-xs md:text-sm select-none flex items-center" *ngIf="showRangeInfo">
        {{ rangeFrom }} do {{ rangeTo }} z {{ totalCount }}
    </span>

    <div *ngIf="showNavigationButtons" class="flex items-center space-x-1">
        <button class="" mat-icon-button (click)="firstPage()" [disabled]="currentPage === 1 || isLoading" aria-label="First">
            <i class="fal fa-angle-double-left"></i>
        </button>
        <button class="" mat-icon-button (click)="prevPage()" [disabled]="currentPage === 1 || isLoading" aria-label="Previous">
            <i class="fal fa-angle-left"></i>
        </button>
        <span class="mx-1 text-xs md:text-sm select-none flex items-center" *ngIf="showPageInfo">
            <span *ngIf="!isLoading">Stránka {{ currentPage }} z {{ totalPages }}</span>
            <span *ngIf="isLoading" class="flex items-center">
                <mat-spinner [diameter]="16" class="mr-1"></mat-spinner>
            </span>
        </span>
        <button class="" mat-icon-button (click)="nextPage()" [disabled]="currentPage >= totalPages || isLoading" aria-label="Next">
            <i class="fal fa-angle-right"></i>
        </button>
        <button class="" mat-icon-button (click)="lastPage()" [disabled]="currentPage >= totalPages || isLoading" aria-label="Last">
            <i class="fal fa-angle-double-right"></i>
        </button>
    </div>
</div>
